import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetListTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_TOURNAMENT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListTournamentAction(data.data))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListTournament as SetGetListTournament
}